import React from 'react';
import {IntegrationTypeFilter} from './IntegrationTypeFilter';
import {IWithDisabled} from 'models';
import {FormNameEnum} from 'filters-selections';

export const IntegrationTypeSingleFilter = ({disabled}: IWithDisabled) => {
  return <IntegrationTypeFilter selectionType="single" disabled={disabled} name={FormNameEnum.integrationType} />;
};
